import CryptoJS from 'crypto-js';

const AES_IV = 'jinrong58haojie0';

export function aesEncrypt(text, aesKey) {
    const encrypted = CryptoJS.AES.encrypt(text, CryptoJS.enc.Latin1.parse(aesKey), {
        iv:  CryptoJS.enc.Utf8.parse(AES_IV),
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });

    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
}

export function aesDecrypt(text, aesKey) {
    const decrypted = CryptoJS.AES.decrypt(text, CryptoJS.enc.Utf8.parse(aesKey), {
        iv: CryptoJS.enc.Utf8.parse(AES_IV),
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    const data = decrypted.toString(CryptoJS.enc.Utf8);
    return data;
}